import React from 'react';
import { useTranslation } from 'react-i18next';
import { ManageProducts } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { FiltersProvider } from '@context';

export function ManageProductsPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('manage-products-component.metatags.title'),
        description: t('manage-products-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myProducts,
        index: false,
    });

    return (
        <FiltersProvider>
            <ManageProducts />
        </FiltersProvider>
    );
}
